const View = require('public_framework/view')
const { throttle, debounce, noop } = require('underscore')
const $ = require('jquery')

// Makes menu link active on scroll.

class Content extends View {
  constructor () {
    super(...arguments)

    this.listen('charts:rendered', debounce(this.onResize.bind(this), 100))
    $(window).on('resize.content', throttle(this.onResize.bind(this), 100))
    $(window).on('scroll.content', throttle(this.onScroll.bind(this), 100))

    this.onResize()
    this.onScroll()

    this.trackingCategory = this.$navbar().data('trackingCategory')

    this.classes = {
      isExpanded: 'is-expanded'
    }

    this._nextAnchor = null

    // Key learnings behavior
    const CLOSED_CLASS = 'is-closed'
    this.$key_learning_titles().addClass(CLOSED_CLASS)
    this.$key_learning_titles().on('click', function () {
      $(this).toggleClass(CLOSED_CLASS)
    })
  }

  get els () {
    return {
      $content: '@content',
      $navbar: '@navbar',
      $titles: '@content h2,h3[id]',
      $key_learning_titles: '@content [data-role=key_learning_title]'
    }
  }

  get events () {
    return {
      'click .has-children': 'handleToggleExpand',
      'click .sidebar_menu-link': 'handleAnchorClick',
      'mousedown @cta': 'handleCtaClick',
      'click @link': 'handleSocialShareButtonClick'
    }
  }

  handleCtaClick (e) {
    const [category = '', action = '', label = ''] = $(e.currentTarget).data('ga').split('|').map(param => param.trim())

    if (category || action || label) {
      // We need to send noop as callback to prevent it to redirect to the href of the target element.
      window.googleAnalytics.trackEvent(e, category, action, label, noop)
    }
  }

  handleSocialShareButtonClick (e) {
    const category = 'social_networks'
    const action = 'share'
    const label = $(e.currentTarget).data('type')

    if (label) {
      window.googleAnalytics.trackEvent(e, category, action, label, noop)
    }
  }

  unload () {
    $(window).off('.content')
  }

  onScroll () {
    const top = $(window).scrollTop()
    this._findActiveElement(top + this._topOffset)
  }

  onResize () {
    this._topOffset = $(window).innerHeight() / 2
  }

  selectFirst () {
    const titles = this._getTitlesData()
    this._setActiveLink(titles[titles.length - 1].id)
  }

  handleToggleExpand ({ target }) {
    this._collapseSiblings($(target).toggleClass(this.classes.isExpanded))
  }

  handleAnchorClick (e) {
    const url = e.currentTarget.href
    const hash = url.substring(url.indexOf('#') + 1)
    this._nextAnchor = hash

    if (this.trackingCategory) {
      window.googleAnalytics.trackEvent(e, this.trackingCategory, 'sidenav_click', hash)
    }

    this._collapseSiblings($(e.target))
      .filter('.has-children')
      .not(`.${this.classes.isExpanded}`)
      .addClass(this.classes.isExpanded)
  }

  _collapseSiblings ($node) {
    return $node
      .closest('li')
      .siblings('.has-children')
      .removeClass(this.classes.isExpanded)
      .end()
  }

  _findActiveElement (topOffset) {
    let nearestTitle = this._getTitlesData().find(title => {
      return topOffset >= title.offset
    })

    if (this._nextAnchor) {
      if (nearestTitle && nearestTitle.id === this._nextAnchor) {
        this._setActiveLink(nearestTitle.id)
        this._nextAnchor = null
      }
    } else if (nearestTitle == null) {
      this.selectFirst()
    } else if (nearestTitle.id !== this._activeLink) {
      this._setActiveLink(nearestTitle.id)
    }
  }

  _setActiveLink (id) {
    this._activeLink = id
    let link = this.$navbar().find(`a[href="#${id}"]`)
    this.$navbar().find('.is-active').removeClass('is-active')
    link.parent('li').addClass('is-active')

    const itemToExpand = link.parents('ul').hasClass('is-inner') ? link.parents('ul').parent('li') : link.parent('li')
    const expandedItem = this.$navbar().find('.is-expanded')

    if (itemToExpand !== expandedItem) {
      expandedItem.removeClass('is-expanded')
      if (itemToExpand.hasClass('has-children')) {
        itemToExpand.addClass('is-expanded')
      }
    }
  }

  _getTitlesData () {
    let titlesEls = this.$titles().get().reverse()
    return titlesEls.map(title => ({
      id: title.id, offset: $(title).offset().top
    }))
  }
}

module.exports = Content



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/content_menu_tracker.js